import { request} from '../lib/request';

const functionGroupAllocationApi = request({
    baseURL: process.env.REACT_APP_BASE_API + 'secondary-vehicle-repair-agent'
});

export const updateFunctionGroupAllocation = async (id, payload) => {
    return await functionGroupAllocationApi.post(`/${id}/function-group`, payload);
}